<template>
  <v-card>
    <router-link :to="cardDetailsLink">
      <v-img :aspect-ratio="9 / 16" :src="template.thumbnail"></v-img>
    </router-link>

    <v-chip
      v-if="isDraft || isPurchased"
      label
      color="grey"
      text-color="white"
      class="draft_badge"
    >
      <v-icon left small color="white" v-text="mdiEmailOpen"></v-icon>
      {{ isPurchased ? $t("PURCHASED") : $t("DRAFT") }}
    </v-chip>

    <v-card-actions v-if="isDraft" class="justify-space-between">
      <span v-if="template.card_for == GROOM_SIDE">
        {{ template.groom_details.first_name }}
      </span>
      <span v-else> {{ template.bride_details.first_name }}'s card </span>
    </v-card-actions>

    <v-card-actions v-else class="justify-space-between">
      <span>
        {{ template.currency_symbol }}
        {{ template.price_android_discounted }}
      </span>
      <v-btn icon @click="toggleBookmark(template)">
        <v-icon
          :color="template.bookmark_active ? 'primary' : ''"
          v-text="mdiHeart"
        >
        </v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import keys from "@/app-js/keys.js";
import urls from "@/app-js/urls.js";
import { mdiHeart, mdiEmailOpen } from "@mdi/js";

export default {
  name: "ThumbnailPreview",
  props: {
    template: {
      type: Object,
      default: () => ({
        id: 0,
        language: "English",
        parents_support: false,
        grandparents_support: false,
        multiple_function_support: false,
        special_message_support: false,
        rsvp_support: false,
        max_function_limit: 0,
        special_message2_support: false,
        main_date_modification_support: false,
        main_venue_modification_support: false,
        price_android_discounted: 0,
        price_android_original: 0,
        price_ios_discounted: 0,
        ios_product_id: 0,
        bookmark_active: false,
        currency_symbol: "₹",
        android_product_id: 0,
        pages: "single",
        offers_personalised_invite: false,
        thumbnail: "",
        pdf_url: "",
        html_url: "",
        image_list: [],
        field_group_list: [],
        template_name: "",
        flag_send_for_free: false
      })
    },
    isDraft: Boolean,
    isPurchased: Boolean
  },

  data() {
    return {
      mdiHeart,
      mdiEmailOpen,
      category_name: "",
      category_id: "",
      template_list: [],
      GROOM_SIDE: keys.GROOM_SIDE
    };
  },

  computed: {
    cardDetailsLink() {
      if (this.isDraft)
        return { name: "previewCard", params: { card_id: this.template.id } };
      else if (this.isPurchased)
        return { name: "downloadCard", params: { card_id: this.template.id } };
      else
        return {
          name: "templatesDetails",
          params: { template_id: this.template.id }
        };
    }
  },

  methods: {
    async toggleBookmark(template) {
      const url = urls.BOOKMARK;
      const form = new FormData();
      form.append("template_id", template.id);
      form.append("lang", template.language);
      form.append("flag_bookmark", !template.bookmark_active);

      const response = await this.$axios.post(url, form);
      if (response.data.success) {
        template.bookmark_active = !template.bookmark_active;
      }
    }
  }
};
</script>

<style scoped>
.draft_badge {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
